module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (195).57d8ee73.jpg";